import { BaseEntitiesService } from './BaseEntitiesService';
import { MessagesRepository } from '../repositories/vcp';
import { createObjectsCache } from '../singleton';
export class MessagesService extends BaseEntitiesService {
    attachment_id;
    constructor(attachment_id) {
        super(new MessagesRepository(attachment_id));
        this.attachment_id = attachment_id;
    }
    _dispose() {
        MessagesService._cache.remove(this.attachment_id);
        super._dispose();
    }
    static _cache = createObjectsCache((attachment_id) => new MessagesService(attachment_id), '__vcp__messages');
    static createInstance = MessagesService._cache.get;
}
